import { Form } from 'antd';
import styled from 'styled-components';

export default styled(Form)`
	// Add your styles here
`;
